import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { switchMap, map, tap } from 'rxjs/operators';
import { RouteService } from '@services/route.service';
import { GlobalService } from '@services/global.service';
import { Tag, Filter } from '@models/product';

@Component({
  selector: 'gob-tag-form',
  templateUrl: './tag-form.component.html',
  styleUrls: ['./tag-form.component.css']
})
export class TagFormComponent implements OnInit {
  loading: boolean=false;
  error: string;
  msg: string;
  tag: Tag;
  filters: Filter[]=[];

  constructor(public route: RouteService, private router: ActivatedRoute, private gServ: GlobalService) {
    this.loading=true;
    this.tag=new Tag();
    this.router.paramMap
      .pipe(
        switchMap(params => {
          if(params.get('id')){
            return this.gServ.getTags()
                      .pipe(
                        map(tags => tags.find(c => c.ident==params.get('id'))),
                        tap(tag => this.tag=JSON.parse(JSON.stringify(tag)))
                      );
          }
          else
            return of(new Tag());
        }),
        switchMap(() => this.gServ.getFilters()),
        tap(filters => this.filters=filters)
      )
      .subscribe({
        next: () => this.loading=false,
        error: e => {
          this.error=e;
          this.loading=false;
        }
      });
  }

  ngOnInit(): void {
  }

  isActive(ident: string){
    return (this.tag.filters.findIndex(filter => filter==ident)!=-1 || this.isDefault(ident));
  }

  isDefault(ident: string){
    return (ident=="filter-price" /* || ident=="filter-age" || ident=="filter-players" */);
  }

  setFilter(ident: string, event: any){
    if(event.target.checked)
      this.tag.filters.push(ident);
    else
      this.tag.filters.splice(this.tag.filters.findIndex(filter => filter==ident), 1);
  }

  update(form: any){
    this.loading=true;
    let update: boolean=(this.tag.ident!=null);
    this.gServ.setTag(this.tag).subscribe({
      next: () => {
        this.msg='Modification enregistrée';
        if(!update)
          form.reset();
        this.loading=false;
      },
      error: e => {
        this.error=e;
        this.loading=false;
      }
    });
  }

  rm(){
    if(confirm("Etes-vous sur de vouloir supprimer ?")){
      this.loading=true;
      this.gServ.rmTag(this.tag.ident).subscribe({
        next: () => this.route.navigate('class-list'),
        error: e => {
          this.error=e;
          this.loading=false;
        }
      });
    }
  }
}
